module.exports = __webpack_public_path__ + "img/home-8.6f34eafb.webp";